module.exports = __webpack_public_path__ + "static/img/jinan2.6ad87bdf.jpg";